// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const espathra: PokeData = {
  "id": 956,
  "name": "espathra",
  "height": 19,
  "weight": 900,
  "base_experience": 168,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "growl",
    "psybeam",
    "peck",
    "drill-peck",
    "confusion",
    "psychic",
    "agility",
    "quick-attack",
    "uproar",
    "feather-dance",
    "pluck",
    "last-resort",
    "disarming-voice",
    "dazzling-gleam",
    "baby-doll-eyes",
    "lumina-crash"
  ],
  "moves": [
    "growl",
    "peck",
    "psychic",
    "quick-attack",
    "dazzling-gleam",
    "healing-wish",
    "psychic-fangs",
    "prismatic-cage",
    "psychic-terrain",
    "reflect",
    "zen-headbutt",
    "psywave",
    "psy-pulse"
  ],
  "evolution_chain": {
    "id": 500,
    "item": null,
    "species": [
      {
        "name": "flittle",
        "order": 926,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "espathra",
        "order": 927,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 955,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 109,
    "speed": 148,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
